import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';

import { ProductType } from '@/components/Billing/billing-types';

export default /*#__PURE__*/_defineComponent({
  __name: 'BillingDowngradePending',
  props: {
	isLoading: Boolean,
	productId: String,
	planReadableName: String,
	downgradeReadableDate: String,
	downgradePlanReadableName: String,
},
  emits: ["cancel-downgrade"],
  setup(__props, { emit }: { emit: ({
	(e: 'cancel-downgrade'): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props



const isTeamFeature = computed(() => props.productId === ProductType.TeamFeatures);
const isQuantityReduce = computed(() => props.downgradePlanReadableName === props.planReadableName);
const quantityReducedText = computed(() => {
	switch (props.productId) {
		case ProductType.TeamFeatures:
			return `Your workspace will stay on ${props.downgradePlanReadableName}. Your user quota will decrease starting from the next cycle.`;
		case ProductType.CustomerFeatures:
			return `Your customer features task quota will decrease starting from next cycle.`;
		case ProductType.Automation:
			return `Your automation task quota will decrease starting from next cycle.`;
		case ProductType.Credits:
			return `Your Ply credit quota will decrease starting from next cycle.`;
		default:
			return '';
	}
});

return { __sfc: true,emit, props, isTeamFeature, isQuantityReduce, quantityReducedText }
}

})